import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
export interface Props {scroll : any}
export const Section4:React.FC<Props> = ({scroll}) => {
    const {t} = useTranslation()
    const navigate = useNavigate()
    return(
        <>
        <section className="mainSection_4">
            <div ref={(e)=>scroll.current[3]=e}>
                <h2>
                    <span>{t("main_section_7")}</span>
                    LIEBHERR & HYUNDAI Engine
                </h2>
                <div>
                    <div className="imgBox" onClick={()=>navigate('/liebherr/marineEngine')}>
                        <div>
                            <span></span>
                            <span>{t("main_section_8")}</span>
                        </div>
                        <img src="/assets/images/mainSection_4_liebherr.png" alt="LIEBHERR"/>
                        <button className="moreViewBtn_black" onClick={()=>navigate('/liebherr/marineEngine')}>more view</button>
                    </div>
                    <div className="imgBox" onClick={()=>navigate('/liebherr/generatorEngine')}>
                        <div>
                            <span></span>
                            <span>{t("main_section_9")}</span>
                        </div>
                        <img src="/assets/images/mainSection_4_hyundai.png" alt="HYUNDAI"/>
                        <button className="moreViewBtn" onClick={()=>navigate('/liebherr/generatorEngine')}>more view</button>
                    </div>
                </div>
            </div>
        </section>
        </>
    )
}